export default __webpack_public_path__ + "static/media/empl_indirect.70ab97ca.svg";